import type { ChannelMacros } from '@melodinai/types';
import { MACRO_LABELS } from './macros/mapMacros';
import { clsx } from '../../lib/utils';

interface SimpleMacrosProps {
  macros: ChannelMacros;
  onChange: (key: keyof ChannelMacros, value: number) => void;
  compact?: boolean;
}

export function SimpleMacros({ macros, onChange, compact }: SimpleMacrosProps) {
  return (
    <div className={clsx('grid gap-2', compact ? 'grid-cols-2' : 'grid-cols-4')}>
      {MACRO_LABELS.map(({ key, label, hint }) => (
        <label key={key} className="flex flex-col gap-1" title={hint}>
          <span className="text-[9px] font-semibold uppercase tracking-wider text-ssl-accent">{label}</span>
          <input
            type="range"
            min={0}
            max={1}
            step={0.01}
            value={macros[key] ?? 0}
            onChange={(e) => onChange(key, Number(e.target.value))}
            className="h-1.5 w-full cursor-pointer accent-ssl-accent"
          />
          <span className="text-[9px] tabular-nums text-ssl-muted">{Math.round((macros[key] || 0) * 100)}</span>
        </label>
      ))}
    </div>
  );
}
